<template>
    <div class="agency_settings org_settings">
        <nav id="agency-setting-tab-nav" class="col-12 navbar navbar-expand primary-tab-bar">
            <div class="container-fluid">
                <div class="collapse navbar-collapse">
                    <ul class="navbar-nav">
                        <li 
                            class="nav-item" 
                            v-for="tab_name in setting_tabs" 
                            :key="tab_name"
                        >
                            <a 
                                class="nav-link d-flex flex-nowrap primary-tab"
                                :class="{ 'primary-tab-active': tab_name === setting_tab_name_active }"
                                href="#"
                                role="button"
                                aria-expanded="false"
                                @click.prevent="setActiveTab(tab_name)"
                            >
                                <span>{{ tab_name }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>

        <div v-show="setting_tab_name_active === 'Profile'">
            <agency-profile :agency="local_agency"  :user="user" @agency-updated="updateAgency"/>
        </div>
        <div v-show="setting_tab_name_active === 'Team'" v-if="local_agency">
            <agency-users :agency="local_agency"/>
        </div>
        <div v-show="setting_tab_name_active === 'Clients'" v-if="local_agency">
            <agency-clients :agency="local_agency" :clients="agencyClients"/>
        </div>
        <div v-show="setting_tab_name_active === 'Billing'" v-if="local_agency">
            <billing-settings 
                :entity="local_agency" 
                :entityType="'agency'"
                :user="user">
            </billing-settings>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import AgencyProfile from './AgencyProfile.vue';
import AgencyUsers from './AgencyUsers.vue';
import AgencyClients from './AgencyClients.vue';

export default defineComponent({
    name: 'AgencySettings',
    components: {
        AgencyProfile,
        AgencyUsers,
        AgencyClients
    },
    props: {
        agency: {
            type: Object,
            required: true
        },
        user: {
            type: Object,
            required: true
        },
        agencyClients: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            setting_tabs: this.getAvailableTabs(),
            setting_tab_name_active: 'Profile',
            local_agency: null,
        };
    },
    beforeMount() {
        this.local_agency = this.agency;
        if (!this.agency || !this.agency.id || this.agency.id === -1) {
            this.setting_tab_name_active = 'Profile';
            this.setting_tabs = ['Profile'];
        } else {
            let tab_name = window.location.pathname.split('/').pop();

            if (tab_name === 'profile') {
                this.setting_tab_name_active = 'Profile';
            } else if (tab_name === 'team') {
                this.setting_tab_name_active = 'Team';
            } else if (tab_name === 'clients') {
                this.setting_tab_name_active = 'Clients';
            } else if (tab_name === 'billing') {
                // Only allow billing tab for admin or agency_admin users
                if (this.user && (this.user.user_type === 'admin' || this.user.user_type === 'agency_admin')) {
                    this.setting_tab_name_active = 'Billing';
                } else {
                    // Redirect to profile if user doesn't have billing access
                    this.setting_tab_name_active = 'Profile';
                    window.history.replaceState({}, '', `/admin/agencies/${this.agency.id}/profile`);
                }
            }
        }
    },
    methods: {
        getAvailableTabs() {
            const baseTabs = ['Profile', 'Team', 'Clients'];
            // Only show Billing tab for admin or agency_admin users
            if (this.user && (this.user.user_type === 'admin' || this.user.user_type === 'agency_admin')) {
                baseTabs.push('Billing');
            }
            return baseTabs;
        },
        setActiveTab(tab_name) {
            // Prevent access to billing tab for non-admin users
            if (tab_name === 'Billing' && this.user && (this.user.user_type !== 'admin' && this.user.user_type !== 'agency_admin')) {
                return; // Don't allow setting billing tab for unauthorized users
            }

            this.setting_tab_name_active = tab_name;
            let newURL = `/admin/agencies/${this.local_agency.id}`;

            if (tab_name === 'Profile') {
                newURL += '/profile';
            } else if (tab_name === 'Team') {
                newURL += '/team';
            } else if (tab_name === 'Clients') {
                newURL += '/clients';
            } else if (tab_name === 'Billing') {
                newURL += '/billing';
            }

            window.history.replaceState({}, '', newURL);
        },
        updateAgency(updatedAgency) {
            this.local_agency = updatedAgency;
            this.setting_tabs = this.getAvailableTabs();
            // If this was a new agency, update the URL to include the ID
            if (window.location.pathname.includes('/new')) {
                const newUrl = `/admin/agencies/${updatedAgency.id}/profile`;
                window.history.replaceState({}, '', newUrl);
            }
        },
    }
});
</script>
